'use client';

import {useI18n} from '@udemy-v2/i18n';
import {useClpPurchaseContext} from '@/features/course-landing-page/context/clp-purchase-context.react-component';
import {useClpCourse} from '@/features/course-landing-page/context/clp-course-provider.react-component';
import {
    PlanPeriod,
    PlanPeriodStyle,
    SubscriptionCTA,
    SubscribeFromPageCookie,
} from '@udemy-v2/react-subscription-browse';
import styles from '../subscription-sticky-footer-content/subscription-sticky-footer-cta.module.scss';
import {useFeatures} from '@udemy-v2/react-experimentation';

const UI_REGION = 'non_catalog_pp_sticky_footer';

export const NonCatalogPPStickyFooterCta = () => {
    const {gettext} = useI18n();
    const {nonCatalogPersonalPlan, nonCatalogSubscriptionCTAConfiguration} =
        useClpPurchaseContext();

        const {featureVariantAssignments} = useFeatures(['change_cta_language_for_pp']);
        const changeCtaLangFeatureAssignment = featureVariantAssignments.get(
            'change_cta_language_for_pp',
        )?.configuration as {getStarted: boolean; getPersonalPlan: boolean} | undefined;
    const course = useClpCourse();

    const handleCtaClick = () => {
        SubscribeFromPageCookie.set('course_landing_page', parseInt(course.id, 10));
    };

    if (!nonCatalogPersonalPlan) {
        return null;
    }

    const ctaUrl = `/subscription-checkout/express/?non-catalog-course=${encodeURIComponent(course.id)}`;

    const ctaText = (
        config: {getStarted: boolean; getPersonalPlan: boolean} | undefined,
    ): string => {
        if (!config) {
            return gettext('Start subscription');
        }
        if (config.getStarted && !config.getPersonalPlan) {
            return gettext('Get started');
        }
        if (!config.getStarted && config.getPersonalPlan) {
            return gettext('Get Personal Plan');
        }
        return gettext('Start subscription');
    };

    return (
        <div
            data-testid="non-catalog-pp-sticky-footer"
            data-purpose="non-catalog-pp-sticky-footer"
            className={styles['subscription-cta']}
        >
            <SubscriptionCTA
                uiRegion={UI_REGION}
                subtitleClassName={styles['cta-subtitle']}
                data-purpose="non-catalog-pp-sticky-footer-button"
                offerCtaStyle="primary"
                onCTAClick={handleCtaClick}
                courseId={parseInt(course.id, 10)}
                courseTrackingId={course.frontendTrackingId}
                includeTrialDaysOnCta={false}
                plan={nonCatalogPersonalPlan}
                directCheckout={nonCatalogSubscriptionCTAConfiguration?.directCheckout ?? true}
                purchaseCtaText={
                    nonCatalogSubscriptionCTAConfiguration?.purchaseCtaText ??
                    ctaText(changeCtaLangFeatureAssignment)
                }
                noticeData={{cta_1_url: ctaUrl}}
                showSubtitle={false}
            />
            <div className={styles['cta-subtitle']}>
                <PlanPeriod
                    listPriceText={nonCatalogPersonalPlan.formattedMonthlyAmount}
                    trialPeriodDays={0}
                    showStartingAtPrice={!!nonCatalogPersonalPlan.annualPlanOption}
                    style={PlanPeriodStyle.SINGLE}
                />
            </div>
        </div>
    );
};
